module.exports = "请提供一个 GitHub 或其它代码托管平台仓库的链接。\n\n[什么是*最小化重现*，为什么这是必需的？](#why-repro)\n\n<span class=\"vue-text danger\">请不要乱填一个链接，那只会让你的 issue 被直接关闭。</span>\n"